import { render, staticRenderFns } from "./PromotionsManage.vue?vue&type=template&id=ec7837c0&"
import script from "./PromotionsManage.vue?vue&type=script&lang=js&"
export * from "./PromotionsManage.vue?vue&type=script&lang=js&"
import style0 from "./PromotionsManage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports